// src/components/Pigmy/NewApplication.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { getTodayYYYYMMDD } from '../../utils/dateUtils';
import './NewApplication.css';

const NewApplication = () => {
  const [formData, setFormData] = useState({
    name: '',
    registration_no: '',
    daily_amount: '',
    total_amount: '',
    period: '',
    maturity_date: '',
    finance_name: '',
    date: getTodayYYYYMMDD()
  });

  const [errors, setErrors] = useState({});
  const [registrationNo, setRegistrationNo] = useState(1);

  useEffect(() => {
    const fetchLatestRegistration = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/pimgy/latest-registration`);
        const latestRegNo = response.data.latestRegNo || 0;
        setRegistrationNo(latestRegNo + 1);
        setFormData(prev => ({
          ...prev,
          registration_no: `PM${String(latestRegNo + 1).padStart(3, '0')}`
        }));
      } catch {
        setRegistrationNo(1);
        setFormData(prev => ({ ...prev, registration_no: 'PM001' }));
      }
    };
    fetchLatestRegistration();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    // Update maturity date based on period/date
    if ((name === 'period' && value) || (name === 'date' && formData.period)) {
      const days = name === 'period' ? parseInt(value) || 0 : parseInt(formData.period) || 0;
      const startDate = new Date(name === 'date' ? value : formData.date);
      const maturityDate = new Date(startDate);
      maturityDate.setDate(startDate.getDate() + days);

      const y = maturityDate.getFullYear();
      const m = String(maturityDate.getMonth() + 1).padStart(2, '0');
      const d = String(maturityDate.getDate()).padStart(2, '0');
      setFormData(prev => ({ ...prev, maturity_date: `${y}-${m}-${d}` }));
    }

    if (errors[name]) {
      setErrors(prev => {
        const newErr = { ...prev };
        delete newErr[name];
        return newErr;
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.finance_name) newErrors.finance_name = 'Finance name is required';
    if (!formData.daily_amount || parseFloat(formData.daily_amount) <= 0)
      newErrors.daily_amount = 'Daily amount must be greater than 0';
    if (!formData.period || parseInt(formData.period) <= 0)
      newErrors.period = 'Period must be greater than 0';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      alert('Please fill all required fields correctly.');
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/api/pimgy/new-application`, formData);
      if (response.data.success) {
        alert('Application created successfully!');
        setFormData({
          name: '',
          registration_no: `PM${String(registrationNo + 1).padStart(3, '0')}`,
          daily_amount: '',
          total_amount: '',
          period: '',
          maturity_date: '',
          finance_name: '',
          date: getTodayYYYYMMDD()
        });
        setRegistrationNo(prev => prev + 1);
      }
    } catch (error) {
      console.error('Error creating application:', error);
      alert(error.response?.data?.error || 'Failed to create application.');
    }
  };

  return (
    <div className="pigmy-container">
      <form className="pigmy-form" onSubmit={handleSubmit}>
        <h1 className="pigmy-title">New Pigmy Application</h1>

        <div className="pigmy-section">
          <div>
            <label>Registration No:</label>
            <input type="text" value={formData.registration_no} readOnly />
          </div>
          <div>
            <label>Date: <span className="pigmy-required">*</span></label>
            <input type="date" name="date" value={formData.date} onChange={handleChange} required />
          </div>
        </div>

        <h3 className="pigmy-subtitle">Application Details</h3>
        <div className="pigmy-section">
          <div>
            <label>Name: <span className="pigmy-required">*</span></label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} />
            {errors.name && <p className="pigmy-error">{errors.name}</p>}
          </div>
          <div>
            <label>Finance Name: <span className="pigmy-required">*</span></label>
            <select name="finance_name" value={formData.finance_name} onChange={handleChange}>
            <option value="">Select Partner</option>
      <option value="AMARSINGH THAKUR">AMARSINGH THAKUR</option>
      <option value="DHIRAJ HALLE">DHIRAJ HALLE</option>
      <option value="GURABASAPPA S Y">GURABASAPPA S Y</option>
      <option value="GURURAJ CHINCHURE">GURURAJ CHINCHURE</option>
      <option value="KARABASAPPA MANTAGI">KARABASAPPA MANTAGI</option>
      <option value="LAXMIKANTH CHINCHURE">LAXMIKANTH CHINCHURE</option>
      <option value="RAHUL HADAPAD">RAHUL HADAPAD</option>
      <option value="MALLIKARJUN HALAKE">MALLIKARJUN HALAKE</option>
      <option value="NOOR SHAIKH">NOOR SHAIKH</option>
      <option value="SATISH BERAD">SATISH BERAD</option>
      <option value="SIDDARAM DHAGE">SIDDARAM DHAGE</option>
      <option value="SHAM PUJARI">SHAM PUJARI</option>
      <option value="SHRISHAIL KUMBAR">SHRISHAIL KUMBAR</option>
      <option value="MARUTI TADKAL">MARUTI TADKAL</option>
            </select>
            {errors.finance_name && <p className="pigmy-error">{errors.finance_name}</p>}
          </div>
        </div>

        <div className="pigmy-section">
          <div>
            <label>Daily Amount: <span className="pigmy-required">*</span></label>
            <input type="number" name="daily_amount" value={formData.daily_amount} onChange={handleChange} />
            {errors.daily_amount && <p className="pigmy-error">{errors.daily_amount}</p>}
          </div>
          <div>
            <label>Total Amount (Optional):</label>
            <input type="number" name="total_amount" value={formData.total_amount} onChange={handleChange} />
          </div>
        </div>

        <div className="pigmy-section">
          <div>
            <label>Period (Days): <span className="pigmy-required">*</span></label>
            <input type="number" name="period" value={formData.period} onChange={handleChange} />
            {errors.period && <p className="pigmy-error">{errors.period}</p>}
          </div>
          <div>
            <label>Maturity Date:</label>
            <input type="date" name="maturity_date" value={formData.maturity_date} readOnly />
          </div>
        </div>

        <div className="pigmy-submit-container">
          <button type="submit" className="pigmy-submit">Submit Application</button>
        </div>
      </form>
    </div>
  );
};

export default NewApplication;
